import { PERMISSIONS_VALUE_TYPES, PROPERTY_VALUE_TYPES } from '@dap/memberadmin/config';
import { brandadminApi } from './brandadminApi';
import { PropertyTags } from './tags';
import { ResourceDTO } from '@dap/generated-types';

const tags = [...Object.values(PropertyTags)];

export const propertyApi = brandadminApi.enhanceEndpoints({ addTagTypes: tags }).injectEndpoints({
  endpoints: (build) => ({
    getValueTypes: build.query<Array<string>, void>({
      query: () => PROPERTY_VALUE_TYPES(),
      providesTags: [PropertyTags.VALUE_TYPES],
    }),
    getPermissions: build.query<Array<Resource>, void>({
      query: () => PERMISSIONS_VALUE_TYPES(),
      transformResponse: permissionsMapper,
      providesTags: [PropertyTags.PERMISSIONS],
    }),
  }),
});

export const { useGetValueTypesQuery, useGetPermissionsQuery } = propertyApi;

export function permissionsMapper(resource: Array<ResourceDTO>) {
  return resource.map(dataownerBasicMapper).filter((res): res is Resource => res !== undefined);
}

export type Resource = {
  key: string;
  type?: string;
};

export function dataownerBasicMapper(dataowner?: ResourceDTO): Resource | undefined {
  if (!dataowner) return undefined;

  return {
    key: dataowner?.key ?? '',
    type: dataowner?.type,
  };
}
